import { FC } from 'react';

import DataDateInfo from './components/DataDateInfo';
import { AppVersionTitle, Copyright, FooterContainer, Root } from './styles';
import { Props } from './types';

const Footer: FC<Props> = ({ className }) => {
  return (
    <Root className={className}>
      <FooterContainer>
        <DataDateInfo />

        <Copyright>
          © 2026 PMC Analytics
          <AppVersionTitle> v.{/*gitBranchName*/}2.23.1</AppVersionTitle>
        </Copyright>
      </FooterContainer>
    </Root>
  );
};

export default Footer;
